import api from './api';

const adminSecurityApi = {
  listBlockedRequests: (params = {}) => api.get('/admin/security/blocked-requests', { params }),
  listExemptions: () => api.get('/admin/security/exemptions'),
  addExemption: (data) => api.post('/admin/security/exemptions', data),
  revokeExemption: (id) => api.delete(`/admin/security/exemptions/${id}`),
};

export default adminSecurityApi;
